import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '@/services/api'
import type { DashboardResumen } from '@/types'

/**
 * Hook para obtener el resumen del dashboard ejecutivo.
 *
 * - staleTime: 5 minutos (el dashboard no necesita refresco constante)
 * - select: desenvuelve ApiResponse<DashboardResumen> → DashboardResumen directamente
 * - Expone `refetch` y `isFetching` para el botón de actualización manual
 */
export function useDashboardData() {
  return useQuery<DashboardResumen>({
    queryKey: ['dashboard', 'resumen'],
    queryFn: async () => {
      const res = await dashboardApi.getResumen()
      return res.data
    },
    staleTime: 5 * 60 * 1000,   // 5 min — datos ejecutivos no cambian cada segundo
    refetchOnWindowFocus: false, // evita refetch automático al cambiar de pestaña
  })
}
